export type Feature =
  | 'display'
  | 'audioPermission'
  | 'micPermission'
  | 'localModels'
  | 'cloud'
  | 'permissionsTab'
  | 'onboarding'
  | 'subscription'
  | 'drive-tab';

export const desktopFeatures: Feature[] = [
  'audioPermission',
  'micPermission',
  'localModels',
  'cloud',
  'subscription',
  'permissionsTab',
  'onboarding',
  'display'
];
export const webFeatures: Feature[] = [
  'permissionsTab',
  'subscription',
  'cloud',
  'display',
  'onboarding'
];

// Feature flag utility for Stripe
export function isStripeEnabled(): boolean {
  // Disable Stripe in test environments
  try {
    if (typeof process !== 'undefined' && process.env) {
      const isTestEnv =
        process.env.NODE_ENV === 'test' ||
        process.env.ENVIRONMENT === 'test' ||
        process.env.IS_CICD === 'true';
      if (isTestEnv) return false;

      // Check if STRIPE_API_KEY is set and not empty
      return !!(process.env.STRIPE_API_KEY && process.env.STRIPE_API_KEY.trim() !== '');
    }
  } catch (error) {
    console.error('Error checking Stripe environment variable:', error);
    return false;
  }
  return false;
}
